import css from 'styled-jsx/css';

const styles = css.global`#den-fraudes-golpe {
  background: #C00;
  position: relative;
}

#den-fraudes-golpe .ctn-home-24  {
  height: 100%;
}

#den-fraudes-golpe .img-golpe {
  width: 100%;
  height: 380px;
  object-fit: cover;
}

#den-fraudes-golpe picture {
  display: flex;
  width: 100vw;
  position: absolute;
  left: 0;
}

#den-fraudes-golpe .golpe-conteudo {
  padding: 404px 16px 56px;
}

#den-fraudes-golpe .golpe-titulo {
  color:  #FFF;
  font-family: "SantanderHeadline";
  font-size: 48px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px;
  margin: 0;
  position: relative;
  z-index: 9;
}

#den-fraudes-golpe .golpe-texto {
  color: #FFF;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-top: 24px;
  z-index: 9;
  position: relative;
}

#den-fraudes-golpe .golpe-texto a {
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
}

#den-fraudes-golpe .golpe-texto b {
  font-weight: 600;
}

#den-fraudes-golpe .img-denuncia {
  position: absolute;
  top: 0;
  height: 100%;
  right: 46px;
}

#den-fraudes-golpe .img-denuncia.desktop {
  display: none;
}

#den-fraudes-golpe .img-denuncia.mobile {
  position: absolute;
  top: 70%;
  height: 31%;
  right: 0px;
}


@media (min-width: 992px) {
  #den-fraudes-golpe {
    height: 588px;
  }

  #den-fraudes-golpe .mobile {
    display: none;
  }

  #den-fraudes-golpe .img-denuncia.desktop {
    display: block;
  }

  #den-fraudes-golpe .ctn-home-24{
    display: flex;
    gap: 40px;
    align-items: center;
  }

  #den-fraudes-golpe .img-denuncia {
    top: 0;
    height: 100%;
    right: 46px;
  }

  #den-fraudes-golpe picture {
    position: relative;
    width: 60%;
    margin-left: -11%
  }

  #den-fraudes-golpe .golpe-conteudo {
    padding: 0;
    flex: 1;
  }
}`;

export default styles;